import styled from "@emotion/styled";

export const RaffleSection = styled.div<{
  mt?: number;
  mb?: number;
  my?: number;
  ml?: number;
  mr?: number;
  mx?: number;
}>`
  margin-top: ${(props) => props.mt ?? props.my ?? 0}px;
  margin-bottom: ${(props) => props.mb ?? props.my ?? 0}px;
  margin-left: ${(props) => props.ml ?? props.mx ?? 0}px;
  margin-right: ${(props) => props.mr ?? props.mx ?? 0}px;
`;
